__webpack_require__.p = "https://localhost:3042/static/";